
<!-- Site footer -->
<footer class="site-footer">
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-sm-6 col-xs-12">
        <p class="copyright-text">
          No &copy; copyright issues.
        </p>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12">
        <ul class="social-icons">
          <li>
            <a href="https://www.linkedin.com/in/alpnap/" class="linkedin"
              ><i class="fa fa-linkedin"></i
            ></a>
          </li>
          <li>
            <a href="https://www.instagram.com/the_alp_darpan/" class="dribbble"
              ><i class="fa fa-instagram"></i>
            </a>
          </li>
          <li>
            <a href="https://twitter.com/alpna_p" class="twitter"
              ><i class="fa fa-twitter"></i
            ></a>
          </li>
          <li>
            <a href="https://github.com/alpnaP" class="github"><i class="fa fa-github"></i></a>
          </li>
          <li>
            <a href="https://www.youtube.com/@CodeWithAlpana" class="youtube"
              ><i class="fa fa-youtube-square"></i>
            </a>
          </li> 
        </ul>
      </div>
    </div>
  </div> 
</footer>
